import { Component } from '@angular/core';

@Component({
    selector: 'app-edit-refund-method-review',
    templateUrl: './edit-refund-method-review.component.html',
    styleUrls: ['./edit-refund-method-review.component.scss']
})
export class EditRefundMethodReviewComponent {
}
